// Fetch list

export const FETCH = 'transportPointStates.FETCH'
export const FETCH_STARTED = 'transportPointStates.FETCH_STARTED'
export const FETCH_FULFILLED = 'transportPointStates.FETCH_FULFILLED'
export const FETCH_REJECTED = 'transportPointStates.FETCH_REJECTED'
export const FETCH_CANCELLED = 'transportPointStates.FETCH_CANCELLED'
